import { render, staticRenderFns } from "./RAViewEmail.vue?vue&type=template&id=5aa99c30&scoped=true&lang=pug&"
import script from "./RAViewEmail.vue?vue&type=script&lang=js&"
export * from "./RAViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./RAViewEmail.vue?vue&type=style&index=0&id=5aa99c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa99c30",
  null
  
)

export default component.exports